import formatTime from '../formatTime';

const DAY = 0;
const HOUR = 1;
const MINUTE = 2;
const SECOND = 3;
type Period = typeof DAY | typeof HOUR | typeof MINUTE | typeof SECOND;

const getName = (isFullName: boolean) => (v: string, period: Period) => {
  const smallAliases = ['d', 'h', 'm', 's'];
  const fullAliases = ['day', 'hour', 'minute', 'second'];
  const multiFullAliases = fullAliases.map(v => `${v}s`);
  const isMulti = parseInt(v, 10) > 1;

  return isFullName ? (isMulti ? multiFullAliases[period] : fullAliases[period]) : smallAliases[period];
};

const createTimeGenerator = (isFullName: boolean) => (times: [string, Period][]) =>
  times.reduce((acc, [value, period]) => {
    const isEmpty = parseInt(value, 10) <= 0;
    const time = isEmpty ? '' : `${value} ${getName(isFullName)(value, period)}`;
    const space = acc && time ? ' ' : '';

    return `${acc}${space}${time}`;
  }, '');

const formatTimeWithAliases = (seconds: number, isFullName = false) => {
  if (!seconds) return '0';

  const generateTime = createTimeGenerator(isFullName);

  const time = formatTime(seconds);
  const timeArray = time.split(':');
  const [v1, v2, v3] = timeArray;

  switch (timeArray.length) {
    case 2: {
      return generateTime([
        [v1, MINUTE],
        [v2, SECOND]
      ]);
    }
    case 3: {
      return generateTime([
        [v1, HOUR],
        [v2, MINUTE]
      ]);
    }
    case 4: {
      return generateTime([
        [v1, DAY],
        [v2, HOUR],
        [v3, MINUTE]
      ]);
    }
  }
};

export default formatTimeWithAliases;
